module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/plus-efbdf439e3a4e242fe793f1c651cfd78.svg";